import { Drawer } from 'vaul';
import { PropsWithChildren } from 'react';

export default function Vaul({
  children,
  trigger,
  open,
  setOpen,
  title,
  description
}: PropsWithChildren<{
  trigger?: React.ReactNode;
  open: boolean;
  setOpen?: (open: boolean) => void;
  title?: string;
  description?: string;
}>) {
  return (
    <Drawer.Root direction="right" open={open} onOpenChange={setOpen}>
      {trigger && <Drawer.Trigger>{trigger}</Drawer.Trigger>}
      <Drawer.Portal>
        <Drawer.Overlay className="fixed inset-0 z-40 bg-black/20 backdrop-opacity-50" />
        <Drawer.Content
          className="fixed top-1 right-1 bottom-1 z-50 flex w-[calc(100%-8px)] rounded-md p-2 outline-none md:w-[400px] lg:w-[500px]"
          // The gap between the edge of the screen and the drawer is 8px in this case.
          style={
            { '--initial-transform': 'calc(100% + 4px)' } as React.CSSProperties
          }
        >
          <div className="bg-card border-border flex h-full w-full flex-col justify-between overflow-hidden rounded-md border p-2 shadow-xl">
            <section>
              {title && (
                <Drawer.Title className="text-card-foreground/80 m-2 text-base font-medium">
                  {title}
                </Drawer.Title>
              )}
              {description && (
                <Drawer.Description className="text-card-foreground/60 mx-2 mb-4 text-sm">
                  {description}
                </Drawer.Description>
              )}
            </section>
            <section className="grow overflow-hidden">{children}</section>
          </div>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  );
}
